/**
 * AI Analytics Metric Enum
 *
 * Available metrics for AI analytics aggregation and sorting.
 */
export var AiAnalyticsMetric;
(function (AiAnalyticsMetric) {
    /** Count of generations */
    AiAnalyticsMetric["COUNT"] = "count";
    /** Total tokens (input + output) */
    AiAnalyticsMetric["TOTAL_TOKENS"] = "totalTokens";
    /** Input tokens */
    AiAnalyticsMetric["INPUT_TOKENS"] = "inputTokens";
    /** Output tokens */
    AiAnalyticsMetric["OUTPUT_TOKENS"] = "outputTokens";
    /** Total estimated cost in USD */
    AiAnalyticsMetric["TOTAL_COST_USD"] = "totalCostUsd";
    /** Average response time in milliseconds */
    AiAnalyticsMetric["AVG_RESPONSE_TIME_MS"] = "avgResponseTimeMs";
})(AiAnalyticsMetric || (AiAnalyticsMetric = {}));
/**
 * AI Analytics Group By Enum
 *
 * Available fields for grouping AI analytics results.
 */
export var AiAnalyticsGroupBy;
(function (AiAnalyticsGroupBy) {
    /** Group by day */
    AiAnalyticsGroupBy["DAY"] = "day";
    /** Group by week */
    AiAnalyticsGroupBy["WEEK"] = "week";
    /** Group by month */
    AiAnalyticsGroupBy["MONTH"] = "month";
    /** Group by AI model */
    AiAnalyticsGroupBy["MODEL"] = "model";
    /** Group by operation type */
    AiAnalyticsGroupBy["OPERATION_TYPE"] = "operationType";
    /** Group by trigger process type */
    AiAnalyticsGroupBy["TRIGGER_PROCESS_TYPE"] = "triggerProcessType";
    /** Group by user ID */
    AiAnalyticsGroupBy["USER_ID"] = "userId";
    /** Group by success status */
    AiAnalyticsGroupBy["SUCCESS"] = "success";
})(AiAnalyticsGroupBy || (AiAnalyticsGroupBy = {}));
//# sourceMappingURL=ai-analytics-metric.enum.js.map